import React, {useContext, useState} from 'react';
import { DarkMode, Home, HomeOutlined, Info, LightMode, ListAltOutlined } from '@mui/icons-material'
import { Icon, List, ListItem, ListItemButton, ListItemText, Drawer, Box, Button, Tooltip, ListItemIcon } from '@mui/material'
import { NavLink, Router, useNavigate} from 'react-router-dom'
import { ThemeContext } from '../../providers';
import routesConfig from '../../RoutesConfig';
import "./Header.css"


export default function Header(props) {

  const [navOpen, setNavOpen] = useState(false);
  const navigate = useNavigate();

  const toggleNav = (newOpen) => () => {
    setNavOpen(newOpen);
  };

  const theme = useContext(ThemeContext);

  const changeThemeHandler = () => {
    if(theme.theme.name === "dark") {
      theme.changeTheme("light");
    }
    if(theme.theme.name === "light") {
      theme.changeTheme("dark");
    }
  }  

  const navList = (
      <Box sx={{ width: 250 }} role="presentation">
        <List>
          {routesConfig.map((route, index) => {
            if (route?.hidden) {
              return null;
            }

            return (<ListItem key={index}>
              <ListItemButton onClick={() => {
                    navigate(route.path);
                    setNavOpen(false);
                  }}>
                  {route?.navIcon ? 
                    <ListItemIcon className="nav-icon">
                      {route.navIcon}
                    </ListItemIcon>
                  : null}
                <ListItemText primary={route.name} />
              </ListItemButton>
            </ListItem>)
          })}
        </List>

      </Box>
  )

  return (
    <div
      className="header-content"
      style={{
        display:'flex',
        alignItems:"center",
        color:theme.text,
        width: "100%",
        background:"#000003",
        height: "3em"
      }}
    >

      <Button onClick={toggleNav(true)} >
        <Home className="home-button" />
        <h4
          style={{
            color:"white",
            margin: "0 1em"
          }}
        >
          NicGauer.com
        </h4>
      </Button>

        <Drawer 
          open={navOpen} 
          onClose={toggleNav(false)}
          keepMounted={false}
        >
        {navList}
      </Drawer>
    </div>
  )
}